<template>
    <v-app>
        <v-app-bar app color="primary" dark>
            <v-row justify="center">
                <div class="d-flex align-center">
                    <h1>Frisbeer st</h1>
                    <h1 @click="adminClick">a</h1>
                    <h1>ts</h1>
                </div>
            </v-row>

            <template v-slot:extension>
                <v-tabs centered>
                    <v-tab to="/">Home</v-tab>
                    <v-tab to="/players">Players</v-tab>
                    <v-tab to="/games">Games</v-tab>
                    <v-tab to="/teams">Teams</v-tab>
                </v-tabs>
            </template>
        </v-app-bar>

        <v-main>
            <router-view />
        </v-main>
        <login :showDialog="dialog" @closeDialog="dialog = false"></login>
    </v-app>
</template>

<script>
import axios from "axios";
import Utils from "./utils.js";
import StatCalculator from "./stats.js";
import Login from "./components/Login";
export default {
    name: "App",
	components: {
		Login
	},
    data() {
        return {
            appName: "Frisbeer stats",
            playerApi: process.env.VUE_APP_API_PLAYERS,
            gamesApi: process.env.VUE_APP_API_GAMES,
            locationsApi: process.env.VUE_APP_API_LOCATIONS,
            clicks: 0,
            dialog: false,
        };
    },
    methods: {
        adminClick() {
            this.clicks++;
            if (this.clicks === 5) {
                this.clicks = 0;
                this.dialog = true;
            }
        },
    },
    mounted() {
        axios.get(this.locationsApi)
            .then(res => {
                this.$store.commit("setLocations", res.data);
            })
            .catch((error) => {
                if (error.response) {
                    console.log("https ERROR", error.response);
                } else {
                    console.log("Unknown error", error);
                }
            });
        Promise.all([axios.get(this.playerApi), axios.get(this.gamesApi)])
            .then((res) => {
                let players = res[0].data;
                let games = res[1].data;
                this.$store.commit("setPlayers", players);

                this.$store.commit("setGames", games);
                Utils.processGames(games);
                let calculator = new StatCalculator(games, players);
                let results = calculator.runSandalfExe();
                this.$store.commit("setSeasonalResults", results.seasonRes);
                this.$store.commit("setSeasonalStats", results.seasonStats);
                Utils.addStatsToPlayers(
                    players,
                    results.seasonStats,
                    this.$store.state.gameStats.seasons
                );
                Utils.calculateElos(games, players);
            })
            .catch((error) => {
                if (error.response) {
                    console.log("https ERROR", error.response);
                } else {
                    console.log("Unknown error", error);
                }
            });
    },
};
</script>
